import { User } from 'shared/types/user';

import { getUserHasPremium } from './get-user-has-premium';

export const getUserHasSubscription = (user: User | null | undefined) => {
  const activeSubscription = user?.subscriptions
    ?.filter(({ unsubscribedAt }) => !unsubscribedAt)
    .sort((subA, subB) => {
      if (!subA.expiresAt) {
        return -1;
      }

      if (!subB.expiresAt) {
        return 1;
      }

      return (
        new Date(subB.expiresAt).getTime() - new Date(subA.expiresAt).getTime()
      );
    })[0];

  return !!(
    getUserHasPremium(user) &&
    activeSubscription?.expiresAt &&
    activeSubscription.expiresAt > new Date()
  );
};

// when a user has a subscription that does not expire, the user is not needed
export const getUserHasLifetime = (user: User | null | undefined) =>
  user?.subscriptions?.find(({ expiresAt }) => !expiresAt);
